import { render } from "./LockView.vue?vue&type=template&id=5bd65cd0&scoped=true"
import script from "./LockView.vue?vue&type=script&lang=js"
export * from "./LockView.vue?vue&type=script&lang=js"

import "./LockView.vue?vue&type=style&index=0&id=5bd65cd0&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd65cd0"]])

export default __exports__